// extracted by mini-css-extract-plugin
export default {"overlay":"ViewMothUnic_overlay__i-AFq","alert":"ViewMothUnic_alert__bgKYV"};